export default __webpack_public_path__ + "static/media/zip.7154e7e9.svg";